/*
 * Picks the visitor's country from the merchant's ship-to list and swaps
 * the flag + name. Shopify Markets (`data-locale-country`) is the first
 * guess; a public country lookup is the second, so stores without Markets
 * still show the right destination.
 */
if (!customElements.get('ss-shipping-to')) {
  customElements.define(
    'ss-shipping-to',
    class SSShippingTo extends HTMLElement {
      connectedCallback() {
        if (this.ssReady) return;
        this.ssReady = true;

        const payload = this.querySelector('[data-ss-shipping-countries]');
        if (!payload) return;

        try {
          this.countries = JSON.parse(payload.textContent);
        } catch (error) {
          return;
        }

        if (!Array.isArray(this.countries) || !this.countries.length) {
          this.hidden = true;
          return;
        }

        this.flag = this.querySelector('[data-ss-shipping-flag]');
        this.nameEl = this.querySelector('[data-ss-shipping-name]');
        this.hideUnknown = this.dataset.hideUnknown === 'true';
        this.fallback = (this.dataset.fallback || '').toUpperCase();

        const locale = (this.dataset.localeCountry || '').toUpperCase();
        this.apply(locale);
        this.detect();
      }

      match(code) {
        const iso = String(code || '').trim().toUpperCase();
        if (!iso) return null;
        return this.countries.find((item) => item.code === iso) || null;
      }

      apply(code) {
        const country =
          this.match(code) ||
          this.match(this.fallback) ||
          (!this.hideUnknown ? this.countries[0] : null);

        if (!country) {
          this.hidden = true;
          return;
        }

        this.hidden = false;
        const iso = country.code.toLowerCase();
        if (this.nameEl) this.nameEl.textContent = country.name;
        if (this.flag) {
          this.flag.src = `https://flagcdn.com/20x15/${iso}.png`;
          this.flag.srcset = `https://flagcdn.com/20x15/${iso}.png 1x, https://flagcdn.com/40x30/${iso}.png 2x`;
          this.flag.alt = `${country.name} flag`;
        }
        this.dataset.activeCountry = country.code;
      }

      async detect() {
        try {
          const response = await fetch('https://api.country.is/', {
            headers: { Accept: 'application/json' },
          });
          if (!response.ok) return;
          const data = await response.json();
          if (data && data.country) this.apply(data.country);
        } catch (error) {
          /* Keep the Markets / fallback country already on screen. */
        }
      }
    }
  );
}
